import { MerchantInterface } from "@/interface/app/ooc";
import { MerchantType } from "@/types/app/ooc/merchant.type";

export default class Merchant implements MerchantInterface {
  list: Array<any> = [];
  totalRows: number = 0;
  name: string = "";
  id: string = "";
  country: string = "";
  integrations: Array<any> = [];
  locations: Array<any> = [];
  integrationName: string = "";
  public static MODULE_NAME: string = "ooc/merchants";

  constructor(data?: MerchantType) {
    if (data) {
      this.id = data.id;
      this.name = data.name || "";
      this.country = data.country || "";
      this.integrations = data.integrations || [];
      this.locations = data.locations || [];
      this.integrationName =
        data.integrations.flatMap((item) => item["integration"]["integration_name"]).join(",") || "";
    }
  }
}
